
    <template>
    <div>
    <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
        <v-container v-else>
            <form @submit.prevent="add_comment_votes" autocomplete="off">
                <v-layout row wrap>
            <v-flex xs12 lg2 xl2 md3 sm4>
            <v-select class="mx-1" clearable rounded filled :items="comments" v-model="comment_votes.comment_id" outlined  item-text="comment_id"
                            item-value="comment_id" :return-object="false" :label="$store.getters.lang.data.comment_id">
                        </v-select>
                        </v-flex>
            
            <v-flex xs12 lg2 xl2 md3 sm4>
            <v-select class="mx-1" clearable rounded filled :items="users" v-model="comment_votes.user_id" outlined  item-text="user_id"
                            item-value="user_id" :return-object="false" :label="$store.getters.lang.data.user_id">
                        </v-select>
                        </v-flex>
            
    <v-flex xs12 lg2 xl2 md2 sm4>
                        <v-btn rounded color="primary" type="submit" x-large >{{$store.getters.lang.data.add_btn}} comment_votes</v-btn>
                    </v-flex>
                </v-layout>
            </form>
            <v-layout row wrap mt-5>
                <v-flex xs12>
                    <v-card>
                        <v-card-title primary-title>
                        {{$store.getters.lang.data.comment_votes}}
                            <v-spacer></v-spacer>
                            <v-text-field autocomplete="off" v-model="search" append-icon="fas fa-search">
                            </v-text-field>
                        </v-card-title>
                        <v-card-text>
                            <v-data-table :headers="headers" :search="search" :items="rows" class="elevation-0"
                                item-key="comment_vote_id">
                                <template v-slot:[`item.comment_vote_id`]="{ item }">
                                    <div>
                                        <v-btn icon color="error" :disabled="$store.state.auth.user.admin_role != 'admin'" class="mx-1" @click="select_comment_votes(item)" rounded>
                                            <v-icon>mdi-delete-outline</v-icon>
                                        </v-btn>
                                        <v-btn :to="'/comment_votes-list/'+item.comment_vote_id" icon color="secondary" class="mx-1"
                                            rounded>
                                            <v-icon>mdi-pencil-outline</v-icon>
                                        </v-btn>
                                    </div>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <v-dialog v-model="delete_dialog" persistent max-width="290">
            <v-card>
                <v-card-title>
                    {{$store.getters.lang.data.delete_question}}
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" class="elevation-0" @click="delete_dialog = false">
                    {{$store.getters.lang.data.cancel_btn}}
                    </v-btn>
                    <v-btn color="green darken-1" text @click="delete_comment_votes(selected_comment_votes.comment_vote_id)">
                    {{$store.getters.lang.data.yes_btn}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar.value" :color="snackbar.color">
            {{snackbar.text}}
        </v-snackbar>
    </div>
</template>
<script>
    import controller from './../../controller/comment_votes'
    export default {
        data() {
            return {
                comment_votes: {},
                search: '',
                loading : true,
                snackbar: {
                    value: false,
                    text: '',
                    color: ''
                },
                selected_comment_votes: {},
                delete_dialog: false,
                headers: [
                    
        {
            text: this.$store.getters.lang.data.comment_vote_id,
            align: 'start',
            sortable: true,
            value: 'comment_vote_id',
        },


        {
            text: this.$store.getters.lang.data.comment_id,
            align: 'start',
            sortable: true,
            value: 'comment_id',
        },


        {
            text: this.$store.getters.lang.data.user_id,
            align: 'start',
            sortable: true,
            value: 'user_id',
        },


                ],
            }
        },
        computed: {
            rows(){
                return this.$store.getters.comment_votes
            },
            
                    comments (){
                        return this.$store.getters.comments
                    },
                    
                    users (){
                        return this.$store.getters.users
                    },
                    
            
        },
        mounted(){
            this.read_comment_votes();
        },
        methods: {
            add_comment_votes() {
                controller.add_comment_votes(this.comment_votes).then(r => {
                    if (r.data) {
                        this.comment_votes = {}
                        this.$store.state.comment_votes.push(
                            r.data.new_data
                        )
                        this.snackbar = {
                            value: true,
                            text: 'comment_votes Added',
                            color: 'success'
                        }
                    } else {
                        this.snackbar = {
                            value: true,
                            text: 'Fail to add comment_votes',
                            color: 'error'
                        }
                    }
                })
            },
            delete_comment_votes(comment_vote_id) {
                controller.delete_comment_votes(comment_vote_id).then(r => {
                    this.delete_dialog = false
                    if (r.data) {
                        this.$store.state.comment_votes = this.$store.state.comment_votes.filter(f =>{
                            return f.comment_vote_id != comment_vote_id
                        })
                        this.snackbar = {
                            value: true,
                            text: 'comment_votes Deleted',
                            color: 'success'
                        }
                    } else {
                        this.snackbar = {
                            value: true,
                            text: 'Delete Faild',
                            color: 'error'
                        }
                    }
                })
            },
            read_comment_votes() {
                this.loading = true
                controller.get_comment_votes().then(r => {
                    // this.rows = r.data.rows
                    this.loading = false
                })
            },
            select_comment_votes(i) {
                this.selected_comment_votes = i
                this.delete_dialog = true
            },
        },
    }
</script>
